import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'bombay-medical-delivery-web-app';

  onActivate() {
    window.scroll(0, 0);
  }
}
